import React from 'react';
import {
    Grid,
    Paper,
    Typography,
} from '@mui/material';
import {
    School as SchoolIcon,
    BarChart as ChartIcon,
    Dashboard as DashboardIcon,
} from '@mui/icons-material';

const StatsCards = ({courses}) => {
    const totalTopics = courses.reduce((total, course) => total + (course.topic_count || 0), 0);
    const totalStudents = courses.reduce((total, course) => total + (course.student_count || 0), 0);

    return (
        <Grid container spacing={3}>
            {/* Course count */}
            <Grid size={{xs: 12, sm: 4}}>
                <Paper sx={{p: 3, textAlign: 'center', height: '100%'}}>
                    <SchoolIcon color="primary" sx={{fontSize: 40, mb: 1}}/>
                    <Typography variant="h4">{courses.length}</Typography>
                    <Typography variant="body1">Courses</Typography>
                </Paper>
            </Grid>

            {/* Topic count */}
            <Grid size={{xs: 12, sm: 4}}>
                <Paper sx={{p: 3, textAlign: 'center', height: '100%'}}>
                    <DashboardIcon color="secondary" sx={{fontSize: 40, mb: 1}}/>
                    <Typography variant="h4">{totalTopics}</Typography>
                    <Typography variant="body1">Topics</Typography>
                </Paper>
            </Grid>

            {/* Student count */}
            <Grid size={{xs: 12, sm: 4}}>
                <Paper sx={{p: 3, textAlign: 'center', height: '100%'}}>
                    <ChartIcon color="success" sx={{fontSize: 40, mb: 1}}/>
                    <Typography variant="h4">{totalStudents}</Typography>
                    <Typography variant="body1">Total Students</Typography>
                </Paper>
            </Grid>
        </Grid>
    );
};

export default StatsCards;